<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Dashboard</span>
  </div>
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
  </div>
</div>
<div class="row">
  <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-danger mt-3 text-center">
        <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
        {{errorMessage}}
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
        {{successMessage}}
      </div>
    </div>
  </div>
</div>

<!-- <div class="row p-3">
  <div class="col-md-12 pt-3 pb-3 bg-white">
    <div class="row">
      <div class="col-md-3 mt-3">
        <span class="theme-font">Lead Count by Status</span>
      </div>
      <div class="col-md-9">
        <div class="row">
          <div class="col-md-4">
            <span>From:</span>
            <input type="date" name="from_date" class=" form-control from_date ss-date" id="from_date" (change)="changeDateFrom($event.target.value)">
            
          </div>
          <div class="col-md-4">
            <span>To:</span>
            <input type="date" name="to_date" class=" form-control to_date ss-date" id="to_date" (change)="changeDateTo($event.target.value)" min = {{date_from}}>
          </div>
          <div class="col-md-3">
            <span>Designer:</span>
            <select class="form-control design_partner ss-design_partner" name="design_partner" id="design_partner" (change)="changeDesigner($event.target.value)">
              <option>Select Designer</option>
              <option *ngFor="let designer of my_designers" [value]="designer.id">{{designer.name}} ({{designer.email}})</option>
            </select>
          </div>
          <div class="col-md-1 text-center cursor-pointer" style="margin-top: -15px;border-left: 1px solid #ecf0f1;margin-bottom: -15px;" (click)="filterDashboard()" >
            <img src="./assets/img/dashboard/submit.png" style="margin-top: 10px;" class="pt-3">
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div> -->

<div class="row">
  <div class="col-md-4">
    <!-- <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/list-request']" [queryParams]="{lead_status: 'leads_total_qualified'}" (click)="showDesignerStatusCountRow('leads_total_qualified')"> -->
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/list-request']">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          Requests
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{dashboardCount.total_requests}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total requests which has to be worked upon.</span>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <!-- <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/list-request']" [queryParams]="{lead_status: 'leads_total_qualified'}" (click)="showDesignerStatusCountRow('leads_total_qualified')"> -->
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/live/list-projects']">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          Live Projects
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{dashboardCount.live_projects}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Currently running products.</span>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <!-- <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/list-request']" [queryParams]="{lead_status: 'leads_total_qualified'}" (click)="showDesignerStatusCountRow('leads_total_qualified')"> -->
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/finished/list-projects']">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          Finished Projects
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{dashboardCount.finished_projects}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Projects which are handed over.</span>
      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/sitesupervisor/dashboard/dashboard.component.html